import {
  DICTATE_REENGAGEMENT_FLAG_KEY,
  DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY,
  type DictateReengagementHintVersion,
} from '@/app-shell/flags/dictate-reengagement-flag';
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { useManualExposure } from '@heidi/analytics/events';
import { ScreenName } from '@heidi/analytics/vocabulary';
import { type DictationReengagementAnalyticsPorts } from '@heidi/dictate/contracts';
import { dictateReengagementCardFlag } from '@heidi/dictate/flags';

export const trackDictateReengagementViewed = (
  variant: DictateReengagementHintVersion | 'general_card'
): void => {
  track({
    event_name: TrackingEventName.ScreenViewed,
    props: {
      screen_name: ScreenName.DictateReengagement,
      version: variant,
    },
    options: { amplitude: false, ...(variant === 'general_card' && { snowplow: true }) },
  });
};

export const useDictateReengagementViewExposure: DictationReengagementAnalyticsPorts['useViewExposure'] =
  (variant, isVisible) => {
    useManualExposure({
      flagKey:
        variant === 'general_card'
          ? dictateReengagementCardFlag.key
          : DICTATE_REENGAGEMENT_FLAG_KEY,
      experimentKey: DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY,
      isEnabled: null,
      variant,
      isVisible,
    });
  };
